import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { CalendarDays, Thermometer } from 'lucide-react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api/time-off`;

// Dashboard shortcut: vacation balance + request / sick buttons (phone-friendly).
export default function TimeOffCard() {
  const [me, setMe] = useState(null);
  const navigate = useNavigate();
  useEffect(() => { axios.get(`${API}/me`).then(r => setMe(r.data)).catch(() => setMe(null)); }, []);
  if (!me) return null;
  const b = me.balance;
  const open = (me.requests || []).filter(r => ['submitted', 'hr_reviewed'].includes(r.status)).length;
  return (
    <div data-testid="time-off-card" className="rounded-xl border border-emerald-200 bg-white p-4 flex flex-col sm:flex-row sm:items-center gap-3 shadow-sm border-l-4 border-l-emerald-600">
      <CalendarDays className="w-6 h-6 shrink-0 text-emerald-600" />
      <div className="flex-1 min-w-0">
        <p className="font-bold text-sm text-slate-900">Time off</p>
        <p className="text-xs text-slate-600" data-testid="time-off-card-balance">
          {b.remaining - b.pending} of {b.total} vacation days left in {b.year}{b.sick_used ? ` · ${b.sick_used} sick` : ''}{open ? ` · ${open} request${open !== 1 ? 's' : ''} pending` : ''}
        </p>
      </div>
      <div className="flex gap-2 shrink-0">
        <button onClick={() => navigate('/time-off')} data-testid="time-off-card-request" className="px-3.5 py-1.5 rounded-lg text-xs font-bold text-white bg-emerald-600 hover:bg-emerald-500 shadow-sm transition-colors">Request time off</button>
        <button onClick={() => navigate('/time-off?sick=1')} data-testid="time-off-card-sick" className="px-3.5 py-1.5 rounded-lg text-xs font-bold text-rose-800 bg-rose-50 hover:bg-rose-100 border border-rose-200 inline-flex items-center gap-1 transition-colors"><Thermometer className="w-4 h-4" /> I'm sick</button>
      </div>
    </div>
  );
}
